import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ChatProvider } from './contexts/ChatContext';
import { InstallPrompt } from './components/pwa/InstallPrompt';
import { AppRoutes } from './AppRoutes';
import { v4 as uuidv4 } from 'uuid';
import { getVisitorId } from './services/fingerprint';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000
    }
  }
});

// Initialize session ID and visitor ID if not exists
if (!sessionStorage.getItem('footyAI_sessionId')) {
  sessionStorage.setItem('footyAI_sessionId', uuidv4());
}

// Initialize visitor ID immediately
getVisitorId().catch(error => {
  console.error('Failed to initialize visitor ID:', error);
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <ThemeProvider>
            <ChatProvider>
              <AppRoutes />
              <InstallPrompt />
            </ChatProvider>
          </ThemeProvider>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}